var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/ProjectList/ProjectList.jinja"] = require( "front/components/ProjectList/ProjectList.jinja" );
dependencies["front/components/ProjectItem/ProjectItem.jinja"] = require( "front/components/ProjectItem/ProjectItem.jinja" );
dependencies["front/components/Video/Video.jinja"] = require( "front/components/Video/Video.jinja" );
dependencies["front/components/Frame/Frame.jinja"] = require( "front/components/Frame/Frame.jinja" );
dependencies["front/components/Quote/Quote.jinja"] = require( "front/components/Quote/Quote.jinja" );
dependencies["front/components/Footer/Footer.jinja"] = require( "front/components/Footer/Footer.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectListPage.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/ProjectList/ProjectList.jinja", false, "ProjectListPage.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("ProjectList", t_1);
env.getTemplate("front/components/ProjectItem/ProjectItem.jinja", false, "ProjectListPage.jinja", function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("ProjectItem", t_4);
env.getTemplate("front/components/Video/Video.jinja", false, "ProjectListPage.jinja", function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("Video", t_7);
output += "<div class=\"ProjectListPage\">\n    <div class=\"Hero\">\n        ";
env.getTemplate("front/components/Frame/Frame.jinja", false, "ProjectListPage.jinja", function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n        ";
output += runtime.suppressValue((lineno = 7, colno = 25, runtime.callWrap(runtime.memberLookup((t_7),"Video"), "Video[\"Video\"]", context, ["work_v2",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "page")),"img")),"main"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"is_tablet"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_14 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_15 = "";;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
return macro_t_14;})()})])), env.opts.autoescape);
output += "\n        ";
env.getTemplate("front/components/Quote/Quote.jinja", false, "ProjectListPage.jinja", function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
output += "\n\n        <button class=\"Hero-btn u-Btn\">\n            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("require").call(context, "front/components/Hero/Hero-btn.svg")), env.opts.autoescape);
output += "\n        </button>\n    </div>\n\n    <div class=\"ProjectListPage-projectList\">\n        ";
output += runtime.suppressValue((lineno = 16, colno = 37, runtime.callWrap(runtime.memberLookup((t_1),"ProjectList"), "ProjectList[\"ProjectLis\"]", context, [runtime.contextOrFrameLookup(context, frame, "hasMore"),runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_21 = "";t_21 += "\n            ";
frame = frame.push();
var t_24 = runtime.contextOrFrameLookup(context, frame, "projects");
if(t_24) {var t_23 = t_24.length;
for(var t_22=0; t_22 < t_24.length; t_22++) {
var t_25 = t_24[t_22];
frame.set("p", t_25);
frame.set("loop.index", t_22 + 1);
frame.set("loop.index0", t_22);
frame.set("loop.revindex", t_23 - t_22);
frame.set("loop.revindex0", t_23 - t_22 - 1);
frame.set("loop.first", t_22 === 0);
frame.set("loop.last", t_22 === t_23 - 1);
frame.set("loop.length", t_23);
t_21 += "\n                ";
t_21 += runtime.suppressValue((lineno = 18, colno = 45, runtime.callWrap(runtime.memberLookup((t_4),"ProjectItem"), "ProjectItem[\"ProjectIte\"]", context, [t_25,runtime.makeKeywordArgs({"caller": (function (){var macro_t_26 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_27 = "";;
frame = frame.pop();
return new runtime.SafeString(t_27);
});
return macro_t_26;})()})])), env.opts.autoescape);
t_21 += "\n            ";
;
}
}
frame = frame.pop();
t_21 += "\n        ";
;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
output += "\n    </div>\n\n    ";
env.getTemplate("front/components/Footer/Footer.jinja", false, "ProjectListPage.jinja", function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
t_28.render(context.getVariables(), frame, function(t_31,t_29) {
if(t_31) { cb(t_31); return; }
output += t_29
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ProjectListPage.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/ProjectListPage/ProjectListPage.jinja
// module id = 52
// module chunks = 0